import { HEIGHT_RANGES } from './constants';
import { floorVideoHeight } from './round-video-size';

export const getMaxRange = (maxHeight: number) => {
    let maxRange = HEIGHT_RANGES[0];
    maxHeight = floorVideoHeight(maxHeight);
    for (let i = 1; i < HEIGHT_RANGES.length; i++) {
        if (maxHeight >= HEIGHT_RANGES[i].min) {
            maxRange = HEIGHT_RANGES[i];
        } else {
            break;
        }
    }

    return maxRange;
};
